import { render, staticRenderFns } from "./DeliveredProducts.vue?vue&type=template&id=79ee4e35&"
import script from "./DeliveredProducts.vue?vue&type=script&lang=js&"
export * from "./DeliveredProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports